import { jwtDecode, JwtPayload } from 'jwt-decode';

export type BaseTokenModel = {
  /** Expiration date of the token */
  expires: number;
  /** User id */
  userId: string;
  /** User name */
  userName: string;
  /** User email */
  email?: string;
  /** User names */
  name?: string;
  /** User roles */
  roles?: string[];
  /** All other properties */
  [key: string]: string | string[] | number | Date | undefined | null | boolean;
};

/**
 * Returns an object including all properties of the JWT required from the user
 */
export const decodeJwt = <T extends BaseTokenModel>(token: string, mapper?: (payload: JwtPayload, data: T) => T): T => {
  const decoded: object = jwtDecode(token);
  const result = {
    expires: decoded['exp' as keyof object] ? decoded['exp' as keyof object] * 1000 : 0,
    userId: decoded['sub' as keyof object] as string | undefined,
    userName: decoded['iss' as keyof object] as string | undefined,
    email: decoded['email' as keyof object] as string | undefined,
    name: decoded['name' as keyof object] as string | undefined,
    roles: (decoded['realm_access' as keyof object] as object)['roles' as keyof object] as string[] | undefined,
  } as T;

  mapper?.call(null, decoded, result);

  return result;
};
